import { getTicketBookSequence, getTicketBookNameForTicketBookId, TheMachineTicketBook } from './ticket-book';

enum TheMachinePrizeType {
  Jackpot = 'jackpot',
  Prize = 'prize'
}

function getPrizeTypeName(prizeType: TheMachinePrizeType): string {
  switch (prizeType) {
    case TheMachinePrizeType.Jackpot:
      return 'Jackpot';
    case TheMachinePrizeType.Prize:
      return 'Prize';
  }
}

function getPrizeTypeNameForLevel(prizeTypeLevel: number): string {
  return getTicketBookNameForTicketBookId(getTicketBookForPrizeLevel(prizeTypeLevel));
}

function getTicketBookForPrizeLevel(prizeTypeLevel: number): TheMachineTicketBook {
  return getTicketBookSequence()[prizeTypeLevel - 1];
}

export { TheMachinePrizeType, getPrizeTypeName, getPrizeTypeNameForLevel, getTicketBookForPrizeLevel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/the-machine/_domain/models/prize-type.ts